module.exports = __webpack_public_path__ + "img/huella_2.fa630e78.gif";